import { Component, inject, signal } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormControlAutocompleteComponent } from '@components/form-control/autocomplete/autocomplete.component';
import { environment } from '@environment';
import {
  UserListResponse,
  Permission,
  User,
  searchResource,
} from '@models';
import { PermissionService } from '@services';

@Component({
  selector: 'app-permission-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    FormControlAutocompleteComponent,
  ],
})
export class PermissionFormComponent {
  dialogRef = inject<MatDialogRef<PermissionFormComponent>>(MatDialogRef);
  private permissionService = inject(PermissionService);
  private permission = inject<Permission>(MAT_DIALOG_DATA);

  public permissionForm: FormGroup;
  public isEdit: boolean;

  userDisplayWith = (u: User) => u.email;
  permissionSearch = signal('');
  permissionResource = searchResource<User[]>(
    () => `${environment.komainuHost}/account/?q=${this.permissionSearch()}`,
    500,
    {
      parse: (value: unknown) => (value as UserListResponse).accounts
    }
  );

  constructor() {
    const permissionService = this.permissionService;
    const permission = this.permission;

    this.isEdit = !!permission;

    const defaultRole = permissionService.getRoleFromPermissions(permission);
    this.permissionForm = new FormGroup({
      role: new FormControl(defaultRole, [Validators.required]),
    });

    if (!this.isEdit) {
      this.permissionForm.addControl(
        'user',
        new FormControl([], [Validators.required]),
      );
    }
  }

  public onSubmit() {
    if (this.permissionForm.pristine || !this.permissionForm.valid) {
      return;
    }

    const formValues = this.permissionForm.value;

    const permissions = this.permissionService.getPermissionsFromRole(
      formValues.role,
    );

    const userId = this.isEdit
      ? this.permission.userId
      : formValues.user.id;

    this.dialogRef.close({
      userId: userId,
      mayRead: permissions.mayRead,
      mayUpdate: permissions.mayUpdate,
      mayDelete: permissions.mayDelete,
    } as Permission);
  }

  public onCancel() {
    this.dialogRef.close();
  }
}
